module.exports = __webpack_public_path__ + "static/media/icon-agep-clock.db799735.svg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Layout/assets/img/icon-agep-clock.svg
// module id = 654
// module chunks = 0